import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BrandRes, BulkDeleteProductPayloadProps, BulkDeleteResponse, CategoryRes, copyoruploadPayload, copyoruploadResponse, CreateProductResponse, DeleteProductResProps, FetchProductAttachmentResponse, GetAllPosProductListResProps, GetAllPosProductPayloadProps, getBulkProductDetailResponse, getBulkProductDetailsPayload, GetOneProductDetails, ModifierResponse, posStoreLocationsNameType, ProductDataProps, ProductPayloadProps, TaxRes, UnitResponse, updateBulkEditProductDetailsPayload, updateBulkEditProductDetailsResponse, UpdateProductPayloadProps, VariantResponse } from "../../components/products/productList/productModule";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";

interface InitialState {
    posProductList: { error: string, value: ProductDataProps[] | null, isLoading: boolean, count?: string },
}

//Defining value for initialState
const initialState: InitialState = {
    posProductList: { error: "", value: null, isLoading: false, count: "" },
}

//Getting all pos product list using getAllPosProductListRedux api call using createAsyncThunk
export const getAllPosProductListRedux = createAsyncThunk("product/getAllPosProductList", ({ storeId, data }: GetAllPosProductPayloadProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosProductList, { storeId })
    return HttpRoutingService?.getMethod<GetAllPosProductListResProps>(url, data,)
})
//Deleting product  using deleteProductRedux api call using createAsyncThunk
export const deleteProductRedux = createAsyncThunk('productSlice/deleteProduct', ({ storeId, id }: ProductPayloadProps) => {
    const url = HttpRoutingService.replaceUrl(API.deleteProduct, { storeId: storeId, id: id })
    return HttpRoutingService.deleteMethod<DeleteProductResProps>(url);
})
//Deleting product using deleteProductRedux api call using createAsyncThunk
export const bulkDeleteProductRedux = createAsyncThunk('productSlice/bulkDeleteProduct', ({ storeId, data }: BulkDeleteProductPayloadProps) => {
    const url = HttpRoutingService.replaceUrl(API.bulkDeleteProduct, { storeId: storeId })
    return HttpRoutingService.putMethod<BulkDeleteResponse>(url, data);
})
//Getting all categories for add edit product using getAllCategoriesNameForPosRedux api call using createAsyncThunk
export const getAllCategoriesNameForPosRedux = createAsyncThunk('productSlice/getAllCategoriesNameForPos', (() => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllCategoriesNameForPos, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<CategoryRes>(url, {},)
}))
//Getting all brands for add edit product using getAllBrandsNameForPosRedux api call using createAsyncThunk
export const getAllBrandsNameForPosRedux = createAsyncThunk('productSlice/getAllBrandsNameForPos', (() => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllBrandsNameForPos, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<BrandRes>(url, {}, "v1/")
}))
//Getting all manual tax for add edit product using getAllPosManualTaxRedux api call using createAsyncThunk
export const getAllPosManualTaxRedux = createAsyncThunk('productSlice/getAllPosManualTax', (() => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosManualTax, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<TaxRes>(url)
}))
//Getting product details for add edit product using getOnePosProductDetailsRedux api call using createAsyncThunk
export const getOnePosProductDetailsRedux = createAsyncThunk('productSlice/getOnePosProductDetails', (({ storeId, id }: ProductPayloadProps) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOnePosProductDetails, { storeId: storeId, id: id })
    return HttpRoutingService?.getMethod<GetOneProductDetails>(url)
}))
export const updateProductDetails = createAsyncThunk('productSlice/updatesProductDetails', ({ storeId, productId, payload }: { storeId: number, productId: number, payload: UpdateProductPayloadProps }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateProductDetails, { storeId: storeId, productId: productId })
    return HttpRoutingService?.putMethod(url, payload)
})
//Getting variant combination for add edit product using getVariantCombinationRedux api call using createAsyncThunk
export const getVariantCombinationRedux = createAsyncThunk('productSlice/getVariantCombination', () => {
    const url = HttpRoutingService?.replaceUrl(API?.getVariantCombination, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<VariantResponse>(url, {}, "v1/")
})
//Getting modifier  for add edit product using getVariantCombinationRedux api call using createAsyncThunk
export const getAllModfierSetRedux = createAsyncThunk("productSlice/getAllModfierSet", () => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllModfierSet, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<ModifierResponse>(url, {}, 'v1/')
})

export const getPosStoreLocationsName = createAsyncThunk("product/getPosStoreLocationsName", () => {
    const url = HttpRoutingService?.replaceUrl(API?.getPosStoreLocationsName, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<posStoreLocationsNameType>(url)
})

export const getBulkProductDetails = createAsyncThunk("product/getBulkProductDetails", ({ payload }: { payload: getBulkProductDetailsPayload }) => {
    const url = HttpRoutingService?.replaceUrl(API?.productBulkEdit, { storeId: config?.storeId })
    return HttpRoutingService?.getMethod<getBulkProductDetailResponse>(url, payload, "v1/")
})

export const updateBulkEditProductDetails = createAsyncThunk("product/updateBulkEditProductDetails", ({ payload }: { payload: updateBulkEditProductDetailsPayload }) => {
    const url = HttpRoutingService?.replaceUrl(API?.productBulkEdit, { storeId: config?.storeId })
    return HttpRoutingService?.putMethod<updateBulkEditProductDetailsResponse>(url, payload)
})

export const copyorupload = createAsyncThunk("product/copyorupload", ({ payload }: { payload: copyoruploadPayload }) => {
    const url = HttpRoutingService?.replaceUrl(API?.copyorupload, { storeId: config?.storeId })
    return HttpRoutingService.postMethod<copyoruploadResponse>(url, payload);
})

export const addProductCatalog = createAsyncThunk("product/addProductCatalog", ({ data, storeId }: { data: FormData, storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl("stores/{storeId}/products/catelog", { storeId })
    return HttpRoutingService.postMethod<CreateProductResponse>(url, data, false, "v1/", { 'Content-Type': 'multipart/form-data' })
})

export const updateProductCatalog = createAsyncThunk("product/updateProductCatalog", ({ data, productId, storeId }: { data: FormData, productId: number, storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl("stores/{storeId}/products/catelog/{productId}", { storeId, productId })
    return HttpRoutingService.putMethod<CreateProductResponse>(url, data, false, "v1/", { 'Content-Type': 'multipart/form-data' })
})
export const fullFillment = createAsyncThunk("product/fullFillment", () => {
    return HttpRoutingService.getMethod<UnitResponse>(`stores/${config?.storeId}/shipping/property/MEASUREMENT/fulfillment`, false, "v1/")
})

export const getPosVariantAttachments = createAsyncThunk("product/getPosVariantAttachments", ({ productId, variantIds }: { productId: number, variantIds: string }) => {
    return HttpRoutingService.getMethod<FetchProductAttachmentResponse>(`stores/${config?.storeId}/products/catelog/${productId}/attachment/?variantIds=${variantIds}`, false, "v1/")
})



//Product Slice 
export const productSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllPosProductListRedux.pending, (state, action) => {
                state.posProductList.isLoading = true
            })
        builder.addCase(getAllPosProductListRedux.fulfilled, (state, action) => {
            const { data: { offset } } = action.meta.arg

            const rowsWithSelection =
                action?.payload?.productList?.rows?.map(item => ({
                    ...item,
                    isSelected: false,
                })) || [];

            state.posProductList.count = action?.payload?.productList?.count;

            if (offset > 0) {
                state.posProductList.value = [
                    ...state.posProductList?.value!,
                    ...rowsWithSelection,
                ];
            } else {
                state.posProductList.value = rowsWithSelection;
            }

        })
            .addCase(getAllPosProductListRedux.rejected, (state, action) => {
                state.posProductList.isLoading = false
                state.posProductList.error = action.error.message as string
            })
    },
})

export default productSlice.reducer